import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import SocialFacebook from './components/SocialFacebook';

import Style from './SocialLogin.module.scss';

const TEST_ID = 'shared-social-login';
const SocialLogin = ({
  facebookGenericError,
  facebookLoginOptionalText,
  facebookLoginText,
  facebookSignupOptionalText,
  facebookSignupText,
  onSocialFacebookLogin,
  showFacebookLogin,
  showFacebookSignup,
  showSignin,
  isConsolidatedSignUp,
}) => {
  const render = showFacebookLogin || showFacebookSignup;
  if (!render) return null;

  return (
    <div className={Style.socialContainer} data-test={TEST_ID}>
      <SocialFacebook
        facebookGenericError={facebookGenericError}
        facebookLoginOptionalText={facebookLoginOptionalText}
        facebookLoginText={facebookLoginText}
        facebookSignupOptionalText={facebookSignupOptionalText}
        facebookSignupText={facebookSignupText}
        onSocialFacebookLogin={onSocialFacebookLogin}
        showFacebookLogin={showFacebookLogin}
        showFacebookSignup={showFacebookSignup}
        isConsolidatedSignUp={isConsolidatedSignUp}
      />
    </div>
  );
};

export default SocialLogin;

SocialLogin.defaultProps = {
  facebookGenericError: null,
  facebookLoginOptionalText: null,
  facebookLoginText: null,
  facebookSignupOptionalText: null,
  facebookSignupText: null,
  onSocialFacebookLogin: noop,
  showFacebookLogin: null,
  showFacebookSignup: null,
  showSignin: null,
};

SocialLogin.propTypes = {
  isConsolidatedSignUp: PropTypes.bool,
  facebookGenericError: PropTypes.string,
  facebookLoginOptionalText: PropTypes.string,
  facebookLoginText: PropTypes.string,
  facebookSignupOptionalText: PropTypes.string,
  facebookSignupText: PropTypes.string,
  onSocialFacebookLogin: PropTypes.func,
  showFacebookLogin: PropTypes.bool,
  showFacebookSignup: PropTypes.bool,
  showSignin: PropTypes.bool,
};
